import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { createClient } from "@supabase/supabase-js";
import ButtonWhite from "../button_white";
import White from "../white";
import Container from "../container";
import Label from "../label";

const supabase_options = {
  db: {
    schema: "public",
  },
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
  global: {
    // headers: { 'x-my-custom-header': 'my-app-name' },
  },
};

const supabase = createClient(
  "https://hdrrfppxfnaxzdmcgjhc.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhkcnJmcHB4Zm5heHpkbWNnamhjIiwicm9sZSI6ImFub24iLCJpYXQiOjE2ODY2NjI1NjIsImV4cCI6MjAwMjIzODU2Mn0.1CSYCMlEd8qIRc0kKhPZ4c5rnQxvaCkIJ_4NSvvqYZs",
  supabase_options,
);

const Form = styled.form`
  text-align: left;
  width: 100%;
  h3 {
    margin-left: 0;
    margin-bottom: 64px;
    margin-top: 98px;
    &:first-of-type {
      margin-top: 0;
    }
  }
`;

const Row = styled.div`
  display: flex;
  column-gap: 30px;
  margin-bottom: ${(props) => (props.mb0 ? "20px" : "80px")};
  justify-content: space-between;
  &.grouped {
    margin-bottom: 0;
  }
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const Col = styled.div`
  display: flex;
  align-items: flex-end;
  width: 100%;
`;

const ButtonContainer = styled.div`
  text-align: right;
  margin-top: 46px;
  .center {
    display: inline-block;
    text-align: center;
  }
  @media (max-width: 768px) {
    text-align: center;
  }
`;

const PayUp = styled.div`
  text-align: center;
  margin-top: 46px;
  h3 {
    margin-left: auto;
    margin-right: auto;
  }
  @media (max-width: 768px) {
    text-align: center;
  }
`;

const Field = styled.div`
  display: flex;
  flex-direction: column;
  border: none;
  width: 100%;
  color: #000;
  ::placeholder {
    color: #aeaeae;
    opacity: 1;
  }
  ::-ms-input-placeholder {
    color: #aeaeae;
  }
  span {
    font-size: 18px;
    color: #aeaeae;
    margin-top: 8px;
  }
  select {
    &:disabled {
      color: #aeaeae;
    }
    margin-top: 14px;
    &:focus {
      outline: 0;
    }
    color: #000;
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 10px;
    max-width: 400px;
    appearance: none;
    background-color: #fff;
    background-position: right 10px center;
    background-repeat: no-repeat;
    background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 28 29' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 9L14 20L24 9' stroke='%23434343' stroke-width='2' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
  }
  input[type="text"],
  input[type="tel"],
  input[type="email"],
  input[type="date"] {
    margin-top: 14px;
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 10px;
    width: 100%;
    color: #000;
    background-color: #fff;
    appearance: none;
    -webkit-appearance: none;
    -webkit-min-logical-width: 100%;
    &:focus {
      outline: 0;
    }
  }
  input[type="date"] {
    @media (max-width: 768px) {
      min-height: 46px;
    }
  }
`;

const Error = styled.span`
  color: red;
  margin-top: 0.5rem;
  display: inline-block;
  font-size: 12px;
`;

const SignupGravel = () => {
  const [formData, setFormData] = useState({
    title: "",
    name: "",
    surname: "",
    email: "",
    mobile: "",
    dob: "",
    address_1: "",
    address_2: "",
    city: "",
    postcode: "",
    region: "",
    country: "",
    kin_title: "",
    kin_name: "",
    kin_surname: "",
    kin_email: "",
    kin_mobile: "",
    kin_address_1: "",
    kin_address_2: "",
    kin_city: "",
    kin_postcode: "",
    kin_region: "",
    kin_country: "",
    route: "",
  });

  const capitalizeFirstLetter = (str) => {
    // Check if the input is a valid string
    if (typeof str !== "string" || str.length === 0) {
      return str;
    }

    // Capitalize the first letter and concatenate with the rest of the string
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const [registered, setRegistered] = useState(false);
  const [registerDisabled, setRegisterDisabled] = useState(true);
  const [registerLabel, setRegisterLabel] = useState("Register");

  const required_fields = [
    "name",
    "surname",
    "email",
    "mobile",
    "dob",
    "address_1",
    "kin_name",
    "kin_surname",
    "kin_email",
    "kin_mobile",
    "kin_address_1",
  ];

  useEffect(() => {
    if (required_fields.every((field) => formData[field] !== "")) {
      setRegisterDisabled(false);
    } else {
      setRegisterDisabled(true);
    }
  }, [formData]);

  const url = typeof window !== "undefined" ? window.location.href : "";

  const handleRegister = async (e) => {
    e.preventDefault();
    setRegisterLabel("Registering...");

    const isBrowser = typeof window !== "undefined";

    if (isBrowser) {
      window.scrollTo(0, 0);
    }

    let { data, error } = await supabase
      .from("gravel_2024")
      .insert([{ ...formData }])
      .select();
    setRegistered(true);
    setRegisterLabel("Next");
  };

  return (
    <White>
      <Container>
        <Form>
          {!registered && (
            <>
              <h3>Your details</h3>
              <Row mb0>
                <Field>
                  <Label>Title</Label>
                  <select
                    onChange={(e) =>
                      setFormData({ ...formData, title: e.target.value })
                    }
                    name="title"
                    id="title"
                  >
                    <option disabled selected>
                      Please select
                    </option>
                    <option
                      selected={formData.title === "mr" ? true : false}
                      value="mr"
                    >
                      Mr
                    </option>
                    <option
                      selected={formData.title === "mrs" ? true : false}
                      value="mrs"
                    >
                      Mrs
                    </option>
                    <option
                      selected={formData.title === "ms" ? true : false}
                      value="ms"
                    >
                      Ms
                    </option>
                    <option
                      selected={formData.title === "miss" ? true : false}
                      value="miss"
                    >
                      Miss
                    </option>
                    <option
                      selected={formData.title === "dr" ? true : false}
                      value="dr"
                    >
                      Dr
                    </option>
                  </select>
                </Field>
              </Row>

              <Row>
                <Col>
                  <Field>
                    <Label>
                      Rider Name <sup>*</sup>
                    </Label>
                    <input
                      required
                      onChange={(e) =>
                        setFormData({ ...formData, name: e.target.value })
                      }
                      value={formData.name}
                      type="text"
                      name="rider_name"
                      id="rider_name"
                      placeholder="First"
                    />
                  </Field>
                </Col>
                <Col>
                  <Field>
                    <Label></Label>
                    <input
                      required
                      onChange={(e) =>
                        setFormData({ ...formData, surname: e.target.value })
                      }
                      value={formData.surname}
                      type="text"
                      name="rider_surname"
                      id="rider_surname"
                      placeholder="Last"
                    />
                  </Field>
                </Col>
              </Row>

              <Row className="grouped">
                <Col>
                  <Field>
                    <Label>
                      Email address <sup>*</sup>
                    </Label>
                    <input
                      required
                      onChange={(e) =>
                        setFormData({ ...formData, email: e.target.value })
                      }
                      value={formData.email}
                      type="email"
                      name="email"
                      id="email"
                      placeholder="name@email.com"
                    />
                  </Field>
                </Col>
                <Col>
                  <Field>
                    <Label>
                      Mobile number <sup>*</sup>
                    </Label>
                    <input
                      required
                      onChange={(e) =>
                        setFormData({ ...formData, mobile: e.target.value })
                      }
                      value={formData.mobile}
                      type="tel"
                      name="mobile"
                      id="mobile"
                      placeholder="+00 00000000000"
                    />
                  </Field>
                </Col>
              </Row>

              <Row>
                <Col>
                  <Field>
                    <Label>
                      Date of birth <sup>*</sup>
                    </Label>
                    <input
                      required
                      onChange={(e) =>
                        setFormData({ ...formData, dob: e.target.value })
                      }
                      value={formData.dob}
                      type="text"
                      placeholder="DD/MM/YYYY"
                      name="dob"
                      id="dob"
                    />
                  </Field>
                </Col>
                <Col>
                  <Field></Field>
                </Col>
              </Row>

              <Row className="grouped">
                <Field>
                  <Label>Address *</Label>
                  <input
                    onChange={(e) =>
                      setFormData({ ...formData, address_1: e.target.value })
                    }
                    value={formData.address1}
                    type="text"
                    name="address_1"
                    id="address_1"
                    placeholder="Address Line 1"
                  />
                  <input
                    onChange={(e) =>
                      setFormData({ ...formData, address_2: e.target.value })
                    }
                    value={formData.address2}
                    type="text"
                    name="address_2"
                    id="address_2"
                    placeholder="Address Line 2"
                  />
                </Field>
              </Row>

              <Row className="grouped">
                <Col>
                  <Field>
                    <input
                      onChange={(e) =>
                        setFormData({ ...formData, city: e.target.value })
                      }
                      value={formData.city}
                      type="text"
                      name="city"
                      id="city"
                      placeholder="City"
                    />
                  </Field>
                </Col>
                <Col>
                  <Field>
                    <input
                      onChange={(e) =>
                        setFormData({ ...formData, region: e.target.value })
                      }
                      value={formData.region}
                      type="text"
                      name="region"
                      id="region"
                      placeholder="State/Province/Region"
                    />
                  </Field>
                </Col>
              </Row>

              <Row mb0>
                <Col>
                  <Field>
                    <input
                      onChange={(e) =>
                        setFormData({ ...formData, postcode: e.target.value })
                      }
                      value={formData.postcode}
                      type="text"
                      name="postcode"
                      id="postcode"
                      placeholder="Postal Code"
                    />
                  </Field>
                </Col>
                <Col>
                  <Field>
                    <input
                      onChange={(e) =>
                        setFormData({ ...formData, country: e.target.value })
                      }
                      value={formData.country}
                      type="text"
                      name="country"
                      id="country"
                      placeholder="Country"
                    />
                  </Field>
                </Col>
              </Row>

              <h3>Next of kin</h3>

              <Row mb0>
                <Field>
                  <Label>Title</Label>
                  <select
                    onChange={(e) =>
                      setFormData({ ...formData, kin_title: e.target.value })
                    }
                    name="kin_title"
                    id="kin_title"
                  >
                    <option disabled selected>
                      Please select
                    </option>
                    <option
                      selected={formData.kin_title === "mr" ? true : false}
                      value="mr"
                    >
                      Mr
                    </option>
                    <option
                      selected={formData.kin_title === "mr" ? true : false}
                      value="mrs"
                    >
                      Mrs
                    </option>
                    <option
                      selected={formData.kin_title === "mr" ? true : false}
                      value="ms"
                    >
                      Ms
                    </option>
                    <option
                      selected={formData.kin_title === "mr" ? true : false}
                      value="miss"
                    >
                      Miss
                    </option>
                    <option
                      selected={formData.kin_title === "mr" ? true : false}
                      value="dr"
                    >
                      Dr
                    </option>
                  </select>
                </Field>
              </Row>

              <Row>
                <Col>
                  <Field>
                    <Label>
                      Name <sup>*</sup>
                    </Label>
                    <input
                      onChange={(e) =>
                        setFormData({ ...formData, kin_name: e.target.value })
                      }
                      value={formData.kin_name}
                      type="text"
                      name="kin_name"
                      id="kin_name"
                      placeholder="First"
                    />
                  </Field>
                </Col>
                <Col>
                  <Field>
                    <Label></Label>
                    <input
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          kin_surname: e.target.value,
                        })
                      }
                      value={formData.kin_surname}
                      type="text"
                      name="kin_surname"
                      id="kin_surname"
                      placeholder="Last"
                    />
                  </Field>
                </Col>
              </Row>

              <Row>
                <Col>
                  <Field>
                    <Label>
                      Email address <sup>*</sup>
                    </Label>
                    <input
                      onChange={(e) =>
                        setFormData({ ...formData, kin_email: e.target.value })
                      }
                      value={formData.kin_email}
                      type="email"
                      name="kin_email"
                      id="kin_email"
                      placeholder="name@email.com"
                    />
                  </Field>
                </Col>
                <Col>
                  <Field>
                    <Label>
                      Mobile number <sup>*</sup>
                    </Label>
                    <input
                      onChange={(e) =>
                        setFormData({ ...formData, kin_mobile: e.target.value })
                      }
                      value={formData.kin_mobile}
                      type="tel"
                      name="kin_mobile"
                      id="kin_mobile"
                      placeholder="+00 00000000000"
                    />
                  </Field>
                </Col>
              </Row>

              <Row className="grouped">
                <Field>
                  <Label>
                    Address <sup>*</sup>
                  </Label>
                  <input
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        kin_address_1: e.target.value,
                      })
                    }
                    value={formData.kin_address_1}
                    type="text"
                    name="kin_address_1"
                    id="kin_address_1"
                    placeholder="Address Line 1"
                  />
                  <input
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        kin_address_2: e.target.value,
                      })
                    }
                    value={formData.kin_address_2}
                    type="text"
                    name="kin_address_2"
                    id="kin_address_2"
                    placeholder="Address Line 2"
                  />
                </Field>
              </Row>

              <Row className="grouped">
                <Col>
                  <Field>
                    <input
                      onChange={(e) =>
                        setFormData({ ...formData, kin_city: e.target.value })
                      }
                      value={formData.kin_city}
                      type="text"
                      name="kin_city"
                      id="kin_city"
                      placeholder="City"
                    />
                  </Field>
                </Col>
                <Col>
                  <Field>
                    <input
                      onChange={(e) =>
                        setFormData({ ...formData, kin_region: e.target.value })
                      }
                      value={formData.kin_region}
                      type="text"
                      name="kin_region"
                      id="kin_region"
                      placeholder="State/Province/Region"
                    />
                  </Field>
                </Col>
              </Row>

              <Row mb0>
                <Col>
                  <Field>
                    <input
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          kin_postcode: e.target.value,
                        })
                      }
                      value={formData.kin_postcode}
                      type="text"
                      name="kin_postcode"
                      id="kin_postcode"
                      placeholder="Postal Code"
                    />
                  </Field>
                </Col>
                <Col>
                  <Field>
                    <input
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          kin_country: e.target.value,
                        })
                      }
                      value={formData.kin_country}
                      type="text"
                      name="kin_country"
                      id="kin_country"
                      placeholder="Country"
                    />
                  </Field>
                </Col>
              </Row>

              <h3>Entry</h3>

              <Row mb0>
                <Col>
                  <Field>
                    <Label>Route</Label>
                    <select
                      onChange={(e) =>
                        setFormData({ ...formData, route: e.target.value })
                      }
                      name="route"
                      id="route"
                    >
                      <option disabled selected>
                        Please select
                      </option>
                      <option
                        selected={
                          formData.route === "World Class Long" ? true : false
                        }
                        value="World Class Long"
                      >
                        World Class Long (Night + Day Stages) — £77
                      </option>
                      <option
                        selected={
                          formData.route === "World Class Short" ? true : false
                        }
                        value="World Class Short"
                      >
                        World Class Short (Night + Day Stages) — £77
                      </option>
                      <option
                        selected={
                          formData.route === "Continental Long" ? true : false
                        }
                        value="Continental Long"
                      >
                        Continental Long (Day Stages) — £77
                      </option>
                      <option
                        selected={
                          formData.route === "Continental Short" ? true : false
                        }
                        value="Continental Short"
                      >
                        Continental Short (Day Stages) — £77
                      </option>
                    </select>
                    <span>Includes £2.00 booking fee</span>
                  </Field>
                </Col>
              </Row>

              <ButtonContainer>
                <div className="center">
                  <ButtonWhite
                    disabled={formData.route !== "" ? false : true}
                    className="hidden snipcart-add-item"
                    data-item-id="gravel_2024"
                    data-item-name={`The Gravel Rally 2024`}
                    data-item-price="77.00"
                    data-item-quantity="1"
                    data-item-url={url}
                    data-item-description={
                      formData.name +
                      " " +
                      formData.surname +
                      " - " +
                      formData.email
                    }
                  >
                    Go to payment
                  </ButtonWhite>

                  <ButtonWhite
                    disabled={registerDisabled}
                    onClick={(e) => handleRegister(e)}
                  >
                    {registerLabel}
                  </ButtonWhite>
                  {registerDisabled === true && (
                    <>
                      <br />
                      <Error>Please complete required fields</Error>
                    </>
                  )}
                </div>
              </ButtonContainer>
            </>
          )}

          {registered && (
            <>
              <PayUp>
                <h3>
                  {formData.name}, you've been registered for the gravel rally!
                </h3>

                <ButtonWhite
                  disabled={formData.route !== "" ? false : true}
                  className="snipcart-add-item"
                  data-item-id="gravel_2024"
                  data-item-name={`The Gravel Rally 2024`}
                  data-item-price="77.00"
                  data-item-quantity="1"
                  data-item-url={url}
                  data-item-description={
                    formData.name +
                    " " +
                    formData.surname +
                    " - " +
                    formData.email
                  }
                >
                  Go to payment
                </ButtonWhite>
              </PayUp>
            </>
          )}
        </Form>
      </Container>
    </White>
  );
};

export default SignupGravel;
